import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_USER = "LOADING_USER";
export const LOADING_ME = "LOADING_ME";
export const ERROR_PROFILE = "ERROR_PROFILE";
export const ERROR_USER = "ERROR_USER";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_DESKTOP_USERS = "GET_ALL_DESKTOP_USERS";
export const GET_ALL_WEB_USERS = "GET_ALL_WEB_USERS";
export const GET_USER = "GET_USER";
export const GET_ME = "GET_ME";
export const ADD_USER = "ADD_USER";
export const UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS";
export const UPDATE_PROFILE_PASSWORD = "UPDATE_PROFILE_PASSWORD";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const DELETE_USER = "DELETE_USER";

export const getAllUsers =
  ({
    clientId = "",
    userType = "",
    ignoreIds = [],
    name = "",
    showUnused = false,
    ignoreTeamId = "",
    page = 1
  } = {}) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_USER,
        payload: true
      });
      const result = await axios().get(
        `/users?client_id=${clientId}&page=${page}&name=${name}&user_type=${userType}&ignore_ids=${ignoreIds.join(
          ","
        )}&show_unused=${showUnused}&ignore_team_id=${ignoreTeamId}`
      );

      dispatch({
        type: LOADING_USER,
        payload: false
      });
      return dispatch({
        type: GET_ALL_USERS,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_USER,
        payload: false
      });
      dispatch({
        type: GET_ALL_USERS,
        payload: null
      });
      dispatch({
        type: ERROR_USER,
        payload: error
      });
    }
  };

export const getAllDesktopUsers =
  ({ clientId = "", name = "", page = 1 } = {}) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_USER,
        payload: true
      });
      const result = await axios().get(
        `/users?client_id=${clientId}&page=${page}&name=${name}&user_type=desktop`
      );

      dispatch({
        type: LOADING_USER,
        payload: false
      });
      return dispatch({
        type: GET_ALL_DESKTOP_USERS,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_USER,
        payload: false
      });
      dispatch({
        type: GET_ALL_DESKTOP_USERS,
        payload: null
      });
      dispatch({
        type: ERROR_USER,
        payload: error
      });
    }
  };

export const getAllWebUsers =
  ({ clientId = "", name = "", page = 1 } = {}) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_USER,
        payload: true
      });

      const result = await axios().get(
        `/users?client_id=${clientId}&page=${page}&name=${name}&user_type=web`
      );

      dispatch({
        type: LOADING_USER,
        payload: false
      });
      return dispatch({
        type: GET_ALL_WEB_USERS,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_USER,
        payload: false
      });
      dispatch({
        type: GET_ALL_WEB_USERS,
        payload: null
      });
      dispatch({
        type: ERROR_USER,
        payload: error
      });
    }
  };

export const getUser = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    const result = await axios().get(`/users/${id}`);
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: null
    });
    dispatch({
      type: GET_USER,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: GET_USER,
      payload: null
    });
    dispatch({
      type: ERROR_USER,
      payload: error
    });
  }
};

export const getMe = () => async dispatch => {
  dispatch({
    type: LOADING_ME,
    payload: true
  });
  try {
    const result = await axios().get(`/users/me`);
    const user = JSON.parse(localStorage.getItem("logged_user"));
    user.fullname = result.data.data.fullname || user.fullname;
    user.email = result.data.data.email || user.email;
    localStorage.setItem("logged_user", JSON.stringify(user));
    dispatch({
      type: GET_ME,
      payload: result.data.data
    });
    dispatch({
      type: ERROR_USER,
      payload: null
    });
    dispatch({
      type: LOADING_ME,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: GET_ME,
      payload: null
    });
    dispatch({
      type: LOADING_ME,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: error
    });
  }
};

export const updateProfileDetails = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    await axios().put(`/users/profile-details`, data);
    const user = JSON.parse(localStorage.getItem("logged_user"));
    user.fullname = data.fullname;
    user.email = data.email;
    localStorage.setItem("logged_user", JSON.stringify(user));
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_PROFILE,
      payload: null
    });
    dispatch({
      type: UPDATE_PROFILE_DETAILS,
      payload: "Profile updated successfully"
    });
  } catch (error) {
    console.error("updateProfileDetails@userAction", error);
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_PROFILE,
      payload: error
    });
  }
};

export const updateProfilePassword = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    await axios().put(`/users/profile-password`, data);
    const user = JSON.parse(localStorage.getItem("logged_user"));
    user.firstname = data.firstname;
    user.email = data.email;
    localStorage.setItem("logged_user", JSON.stringify(user));
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_PROFILE,
      payload: null
    });
    dispatch({
      type: UPDATE_PROFILE_PASSWORD,
      payload: "Password updated successfully"
    });
  } catch (error) {
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: UPDATE_PROFILE_PASSWORD,
      payload: null
    });
    dispatch({
      type: ERROR_PROFILE,
      payload: error
    });
  }
};

export const addUser = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    const result = await axios().post(`/users`, data);
    dispatch({
      type: ERROR_USER,
      payload: null
    });
    dispatch({
      type: ADD_USER,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_USER,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: error
    });
  }
};

export const updateUser =
  ({ id, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_USER,
        payload: true
      });
      const result = await axios().put(`/users/${id}`, {
        ...data,
        role: data?.role?.id
      });
      dispatch({
        type: LOADING_USER,
        payload: false
      });
      dispatch({
        type: ERROR_USER,
        payload: null
      });
      dispatch({
        type: UPDATE_USER,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_USER,
        payload: false
      });
      dispatch({
        type: UPDATE_USER,
        payload: null
      });
      dispatch({
        type: ERROR_USER,
        payload: error
      });
    }
  };

export const updatePassword = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    const result = await axios().put(`/users/password`, data);
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: null
    });
    dispatch({
      type: UPDATE_PASSWORD,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: error
    });
  }
};

export const deleteUser = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_USER,
      payload: true
    });
    const result = await axios().delete(`/users/${id}`);
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: null
    });
    dispatch({
      type: DELETE_USER,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: DELETE_USER,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_USER,
      payload: false
    });
    dispatch({
      type: ERROR_USER,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
